export const environment = {
    production: false,
    url: 'https://api.sensors.smog.datatask.net',
};
